/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABZ0lEQVR4nMVVwU4CQQzdeFFvwhGNX2LkStydthxm22Diiv6DMRg/SeA31KhHMN7Uu4jeNSXKwoLLuEy0SZM5zLzXee28CYL/DGttGUiOAKVrSPpA/K75te4AxM0wbJSKAK8D8RkQvwLJR14alIFBbukZJ3AAqQDK1SJgyBIR30WR3c4Fr9f3t4Dk+bfgML4NP4Wh3fxZFpSbouCQ3uS6miRrMwQG+XxZcBgnn2arL7s0FJylksHUdBnkY3/Vy3c/DtPJQel6JyBupwQkD/4JpJ9KRDLMbogiuxMEwYpL7kG8O4dgmEugh1wJoshW8wlQ7n1LBMi9iR5wxz+BXEz4T9z0TgDxwdRD08fhcURfEJONrFW0vBGgnMx4kRqUGtXy4Hw51+w01GrVcotLI4/6n8wFTxsuFa2igO63Cz+cSbnUcl0arw1VzWu12qoT+LRkjZK64uidIPcMypvmaE3cNiTJzLT8dXwCZObdtx+gdMcAAAAASUVORK5CYII=)
 */
export const CircleMinusIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22ZM7 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
